import { createBrowserRouter } from 'react-router-dom';
import { lazy } from 'react';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import Loadable from 'components/Loadable';

const NotFound = Loadable(lazy(() => import('pages/extra-pages/NotFound')));

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([MainRoutes, LoginRoutes, { path: '*', element: <NotFound /> }], {
  basename: import.meta.env.VITE_APP_BASE_NAME
});

export default router;
